import abilityScores from '@/store/character/abilityScores.js'
import bio from '@/store/character/bio.js'
import race from '@/store/character/race.js'
import misc from '@/store/character/misc.js'
import status from '@/store/character/status.js'
import skills from '@/store/character/skills.js'
import spells from '@/store/character/spells.js'
import equipment from '@/store/character/equipment.js'
import drones from '@/store/character/drones.js'
import companions from '@/store/character/companions.js'
import pools from '@/store/character/pools.js'

const modules = {
	abilityScores,
	bio,
	race,
	misc,
	status,
	skills,
	spells,
	equipment,
	drones,
	companions,
	pools,
}

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
	loadCharacter ( {dispatch}, character){
		for(var submodule in modules){
			if(this._actions[`character/${submodule}/loadCharacter`]){
				dispatch(`character/${submodule}/loadCharacter`, character, {root:true})
			}
		}
	},
	
}

export default {
	namespaced: true,
	modules,
	state,
	getters,
	mutations,
	actions,
}